export const DYNAMIC_INDUSTRY_ROW_ID = [1, 4]
export const ID_LEVEL0_INDUSTRY = 1550

export const COLUMN_ITEMS = {
  INDUSTRY_NAME: 'vsicName',
  COMPANY_NUMBER: 'numberCompanies',
  PERCENT_COMPANY: 'percentCompanies',
  CREDIT_RISK_SCORE: 'creditRiskScore',
  PERFORMANCE_SCORE: 'performanceScore',
}

export const TITLE_TABLE_INDUSTRY_TREND = [
  {
    title: 'portfolio.segment.BASED_ON_VSIC',
    key: COLUMN_ITEMS.INDUSTRY_NAME,
    thStyle: {
      justifyContent: 'start',
    },
    tdStyle: { width: '100%', maxWidth: 0 },
  },

  {
    title: 'portfolio.segment.NUMBER_OF_COMPANIES',
    key: COLUMN_ITEMS.COMPANY_NUMBER,
    thStyle: {
      justifyContent: 'end',
    },
    tdStyle: { textAlign: 'right', minWidth: 180 },
    isChangeTitle: true,
  },

  {
    title: 'portfolio.segment.PERCENT_OF_TOTAL_COMPANIES',
    key: COLUMN_ITEMS.PERCENT_COMPANY,
    thStyle: {
      justifyContent: 'end',
      textAlign: 'right',
    },
    tdStyle: {
      textAlign: 'right',
      minWidth: 180,
    },
  },
  {
    title: 'portfolio.segment.CREDIT_RISK_SCORE',
    key: COLUMN_ITEMS.CREDIT_RISK_SCORE,
    thStyle: {
      justifyContent: 'end',
    },
    tdStyle: {
      textAlign: 'right',
      minWidth: 180,
    },
    isChangeTitle: true,
  },
]

export const CREDIT_RISK_SCORE_COL = {
  title: 'portfolio.summary.CREDIT_RISK_SCORE',
  key: COLUMN_ITEMS.CREDIT_RISK_SCORE,
  thStyle: {
    justifyContent: 'end',
  },
  tdStyle: {
    textAlign: 'right',
    minWidth: 180,
  },
  isChangeTitle: true,
}
